import { NOTIF_DURATION } from '@aibees/shared/constants';
import { OptionsObject, SnackbarKey, useSnackbar } from 'notistack';
import { ReactNode } from 'react';
import { IconType } from '../components';
import { Nullable } from '../definition';

type CustomNotificationOptions = Omit<
  OptionsObject,
  'title' | 'className' | 'variant'
> & {
  icon: IconType;
};
export function useNotify() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  return {
    closeSnackbar,
    success: (message: string) =>
      enqueueSnackbar(message, { variant: 'success', preventDuplicate: false }),
    error: (message: string) =>
      enqueueSnackbar(message, { variant: 'error', preventDuplicate: false }),
    warning: (
      title: Nullable<ReactNode>,
      message: ReactNode,
      key?: SnackbarKey,
      options?: CustomNotificationOptions
    ) =>
      enqueueSnackbar(message, {
        title,
        variant: 'warning',
        autoHideDuration: NOTIF_DURATION,
        hideIconVariant: true,
        preventDuplicate: false,
        persist: false,
        key,
        ...options,
        className: 'WarningSnackbar',
        SnackbarProps: {
          style: { width: '408px' },
        },
      }),
    info: (message: string) => enqueueSnackbar(message, { variant: 'info' }),
    message: (message: string) =>
      enqueueSnackbar(message, { variant: 'default' }), // TODO Sayad change color to white
    progress: (
      title: Nullable<ReactNode>,
      message: ReactNode,
      key?: SnackbarKey,
      options?: CustomNotificationOptions
    ) =>
      enqueueSnackbar(message, {
        title,
        autoHideDuration: NOTIF_DURATION,
        variant: 'progress',
        hideIconVariant: true,
        persist: false,
        key,
        ...options,
        className: 'ProgressSnackbar',
        SnackbarProps: {
          style: { width: '408px' },
        },
      }),
    complete: (
      title: Nullable<ReactNode>,
      message: ReactNode,
      key?: SnackbarKey,
      options?: CustomNotificationOptions
    ) =>
      enqueueSnackbar(message, {
        title,
        variant: 'complete',
        autoHideDuration: NOTIF_DURATION,
        preventDuplicate: false,
        hideIconVariant: false,
        persist: false,
        key,
        ...options,
        className: 'CompleteSnackbar',
        SnackbarProps: {
          style: { width: '408px' },
        },
      }),
    waiting: (
      title: Nullable<ReactNode>,
      message: ReactNode,
      key?: SnackbarKey,
      options?: CustomNotificationOptions
    ) =>
      enqueueSnackbar(message, {
        title,
        variant: 'waiting',
        autoHideDuration: NOTIF_DURATION,
        hideIconVariant: false,
        persist: false,
        key,
        ...options,
        className: 'CompleteSnackbar',
        SnackbarProps: {
          style: { width: '408px' },
        },
      }),

    // TODO Sayad change color to white
  };
}
